function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getOwnerDocument as s } from "../utils/owner.js";
import { useIsoMorphicEffect as d } from "./use-iso-morphic-effect.js";
var i = new Set(),
    r = new Map();

function u(t) {
  t.setAttribute("aria-hidden", "true"), t.inert = !0;
}

function l(t) {
  var n = r.get(t);
  !n || (n["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", n["aria-hidden"]), t.inert = n.inert);
}

function M(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  d(function () {
    if (!n || !t.current) return;
    var o = t.current,
        a = s(o);

    if (!!a) {
      i.add(o);

      var _iterator = _createForOfIteratorHelper(r.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var e = _step.value;
          e.contains(o) && (l(e), r.delete(e));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return a.querySelectorAll("body > *").forEach(function (e) {
        if (e instanceof HTMLElement) {
          var _iterator2 = _createForOfIteratorHelper(i),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var f = _step2.value;
              if (e.contains(f)) return;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          i.size === 1 && (r.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
          }), u(e));
        }
      }), function () {
        if (i.delete(o), i.size > 0) a.querySelectorAll("body > *").forEach(function (e) {
          if (e instanceof HTMLElement && !r.has(e)) {
            var _iterator3 = _createForOfIteratorHelper(i),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var f = _step3.value;
                if (e.contains(f)) return;
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            r.set(e, {
              "aria-hidden": e.getAttribute("aria-hidden"),
              inert: e.inert
            }), u(e);
          }
        });else {
          var _iterator4 = _createForOfIteratorHelper(r.keys()),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var e = _step4.value;
              l(e), r.delete(e);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      };
    }
  }, [n]);
}

export { M as useInertOthers };